import TransitionLink from 'gatsby-plugin-transition-link'
import * as React from 'react'

const ScrollableLink = ({
  type = 'link',
  element = 'site-top',
  activeClassName = 'active',
  state,
  back,
  exitProps,
  entryProps,
  fallback,
  to,
  scrollTo,
  ...rest
}) => {
  // const scrollTo = () => {
  //   const { element } = this.props
  //   const el = document.getElementById(element)

  //   // if (window.innerWidth < maxWidth) {
  //   // setTimeout(() => {

  //   //   el && el.scrollIntoView();
  //   // }, 1000);
  //   // }
  //   window.scrollTo(0, 0)
  // }

  return (
    <TransitionLink
      preventScrollJump
      // onClick={this.scrollTo}
      exit={{
        delay: 0,
        length: 0.4,
        state: { nextPath: to },
        ...exitProps,
      }}
      entry={{
        delay: 0.4,
        length: 0.4,
        state: { nextPath: to },
        ...entryProps,
      }}
      to={
        // back ?
        // location.state &&
        // (location.state.prevPath
        //   ? location.state.prevPath
        //   : fallback)
        //   :
        to
      }
      {...rest}
      state={{
        ...state,
        prevPath: typeof window !== 'undefined' ? window.location.pathname : '',
        // ...location.state,
      }}
    />
  )
}

export default ScrollableLink
